'use strict';
import Layout from './Layout.jsx';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, IndexRoute, Route, hashHistory } from 'react-router';

import ViewError from './views/Error.jsx';
import ViewForgotId from './views/ForgotId.jsx';
import ViewPasswordChooser from './views/PasswordChooser.jsx';
import ViewPhoneAuthentication from './views/PhoneAuthentication.jsx';
import ViewStart from './views/Start.jsx';
import ViewSuccess from './views/Success.jsx';


class App extends React.Component {

    render() {
        // Create application using React Router
        return <Router history={hashHistory}>
            <Route path="/" component={Layout}>
                <IndexRoute component={ViewStart} />
                <Route path="/auth/phone(/:status)" component={ViewPhoneAuthentication} />
                <Route path="/error" component={ViewError} />
                <Route path="/forgotId" component={ViewForgotId} />                                
                <Route path="/newpw" component={ViewPasswordChooser} />                                
                <Route path="/success" component={ViewSuccess} />
            </Route>
        </Router>;
    }
    
}

// Render app
ReactDOM.render(
    <App />,

    // Target a root node for the app markup to live in
    document.getElementById('application-root'));



// WEBPACK FOOTER //
// ./src/react/App.jsx